import React from 'react';
import { Box } from '@mui/material';
export default function Entries() {
    return (
        <Box>
            <text className='white medium'>Entries</text>
        </Box>
    )
}
